export default __webpack_public_path__ + "static/media/Food_08.39bc0ee8.png";